module.exports = __webpack_public_path__ + "static/media/logo512.64977f77.png";